<div class="sz-numpad-grid">
  @for (key of keys(); track $index) {
    <button
      type="button"
      class="sz-numpad-grid__key"
      [class.sz-numpad-grid__key--fn]="key.variant === 'fn'"
      [class.sz-numpad-grid__key--icon]="key.variant === 'icon'"
      [disabled]="disabled()"
      (click)="onPress(key.value)">
      @if (key.icon; as iconName) {
        <sz-icon [name]="iconName" [size]="20" />
      } @else {
        {{ key.label }}
      }
    </button>
  }
</div>
